<div class="container mt-4">
  <div class="row mt-3 mb-4 d-flex justify-content-center">
    <div class="col-12 col-lg-8 text-center" *ngIf="showRebrandedMessage; else legacyMessage">
      <p class="h3 fw-bold mb-2">You’re all set!</p>
      <p class="mb-2">{{ thankYouMessage }}</p>
      <p class="mb-2">Check your inbox for the next steps and everything you need to get started with your subscription.</p>
      <p class="mb-0">We’re so happy to have you with us</p>
    </div>

    <ng-template #legacyMessage>
      <p class="text-center">{{ thankYouMessage }}</p>
    </ng-template>
  </div>
</div>

<ng-container *appFeatureFlag="'isAdestraAvailable'">
  <div *ngIf="isAdestraTagReady" class="d-none">
    <img src="http://mail.identi.pet/v/?tag={{ subAdestraTag }}" />
  </div>
</ng-container>
